export default __webpack_public_path__ + "static/media/page1-img_03_original.604f1605.jpg";